// Core
import React, { useState, useEffect } from "react";

// Components - Contrib
import { Container, Row, Col } from "react-bootstrap";
import { HashRouter, Navigate, Routes, Route } from "react-router-dom";

// Components - Custom
import Sidebar from "./components/sidebar";
import AlphaHeader from "./components/alphaheaders";
import SearchResults from "./components/searchresults";

import { fetchCategory } from "./data/apis";

function App() {
	const [subjectAreas, setSubjectAreas] = useState();

	useEffect(() => {
		(async () => {
			var response = await fetchCategory(3);
			setSubjectAreas(response);
		})();
	}, []);

	if (!subjectAreas) return null;

	return (
		<HashRouter>
			<Container className="p-0" fluid>
				<Row>
					<Col sm={12} lg={3}>
						<Sidebar data={subjectAreas} />
					</Col>
					<Col sm={12} lg={9} style={{ minHeight: "100vh" }}>
						<Routes>
							<Route path="/search/:subjectAreaID/:searchQuery" element={<SearchResults />} />

							{subjectAreas.map((item) => {
								return <Route path={item.URL.replace("#/", "")} key={item.ID} element={<AlphaHeader subjectArea={item} />} />;
							})}
							<Route path="/" element={<Navigate to={subjectAreas[0].URL.split("#/")[1]} />} />
						</Routes>
					</Col>
				</Row>
			</Container>
		</HashRouter>
	);
}

export default App;
